export default __webpack_public_path__ + "static/media/visa.413182c7.svg";